import {Component, HostListener, OnInit, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';

import {AppStoreService} from './store/app-store.service';
import * as fromAuthStore from './auth/store/reducer';
import {AppUIParams} from './shared/app.ui-params';
import {PlatformService} from './shared/platform';
import {MessagingService} from './core/messaging/messaging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./core/styles/common.scss', './app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'bizcate-frontend';

  // UI Params
  backgroundColor: String;

  constructor(private store: Store<fromAuthStore.State>,
              private appStoreService: AppStoreService,
              private platformService: PlatformService,
              private msgService: MessagingService) {
  }

  ngOnInit() {
    this.backgroundColor = AppUIParams.appBackground;

    // Init Store
    this.appStoreService.initApp();

    // Messaging Service
    this.msgService.getPermission()
    this.msgService.receiveMessage()
    const message = this.msgService.currentMessage;
  }

  @HostListener('window:resize')
  onResize() {
    this.platformService.update();
  }
}
